const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export default isInIframe;
